import React, { useState, useContext, FC } from 'react'
import {
  Grid,
  Button,
  Input,
  Checkbox,
  FormControlLabel,
  FormControl,
  CircularProgress,
  makeStyles,
} from '@material-ui/core'
import Auth from '@aws-amplify/auth'
import { useHistory } from 'react-router-dom'
import { SignupContext } from '../../context/SignupContextContainer'

const useStyles = makeStyles({
  progress: {
    marginRight: 10,
  },
})

const SignupForm: FC = () => {
  // booleans for password validations
  const [containsUL, setContainsUL] = useState(false) // uppercase letter
  const [containsLL, setContainsLL] = useState(false) // lowercase letter
  const [containsN, setContainsN] = useState(false) // number
  const [containsSC, setContainsSC] = useState(false) // special character
  const [contains8C, setContains8C] = useState(false) // min 8 characters

  // checks all validations are true
  const [allValid, setAllValid] = useState(false)
  const classes = useStyles()
  const { setSignupInfo } = useContext(SignupContext)

  // labels and state boolean corresponding to each validation
  const mustContainData = [
    { desc: 'Password must contain an uppercase letter (A-Z)', state: containsUL },
    { desc: 'Password must contain a lowercase letter (a-z)', state: containsLL },
    { desc: 'Password must contain a number (0-9)', state: containsN },
    { desc: 'Password must contain a special character (!@#$)', state: containsSC },
    { desc: 'Password must contain at least 8 characters', state: contains8C },
    // ["Passwords match", passwordMatch]
  ]

  const [isLoading, setIsLoading] = useState(false)
  const [userExist, setUserExist] = useState('')
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [checkedTerms, setCheckedTerms] = useState(false)

  const history = useHistory()

  const onTermsChange = (event): void => {
    setCheckedTerms(event.target.checked)
  }

  const validateForm = (): boolean => {
    return email.length > 0 && password.length > 0 && allValid && checkedTerms
  }
  const validatePassword = (): void => {
    // has uppercase letter
    if (password.toLowerCase() !== password) setContainsUL(true)
    else setContainsUL(false)

    // has lowercase letter
    if (password.toUpperCase() !== password) setContainsLL(true)
    else setContainsLL(false)

    // has number
    if (/\d/.test(password)) setContainsN(true)
    else setContainsN(false)

    // has special character
    // eslint-disable-next-line no-useless-escape
    if (/[~`!#$%\^&*+=\-\[\]\\',/{}|\\":<>\?]/g.test(password)) setContainsSC(true)
    else setContainsSC(false)

    // has 8 characters
    if (password.length >= 8) setContains8C(true)
    else setContains8C(false)

    // passwords match
    // if (fields.password !== "" && fields.password === passwordTwo) setPasswordMatch(true)
    // else setPasswordMatch(false)

    // all validations passed
    if (containsUL && containsLL && containsN && containsSC && contains8C) setAllValid(true)
    else setAllValid(false)
  }

  const handleSubmit = async (): Promise<void> => {
    setIsLoading(true)
    try {
      await Auth.signUp({
        username: email,
        password,
        attributes: { name: fullName },
      })
      setIsLoading(false)
      setSignupInfo(email, password)
      history.push('/client/confirmation')
    } catch (e) {
      console.log(e)
      if (e.code === 'UsernameExistsException') {
        setUserExist(e.message)
      } else {
        setUserExist('')
      }
    }
    setIsLoading(false)
  }

  return (
    <div className="signup-form">
      <p className="yes">YES!</p>
      <p className="sub-title">I have the need for speed</p>
      <div className="form">
        <FormControl>
          <Input
            id="fullName"
            placeholder="Full Name"
            autoFocus
            fullWidth
            value={fullName}
            onChange={(e): void => setFullName(e.target.value)}
          />
        </FormControl>
        <FormControl>
          <Input
            id="email"
            placeholder="NAME@DOMAIN.COM"
            fullWidth
            type="email"
            value={email}
            onChange={(e): void => setEmail(e.target.value)}
          />
        </FormControl>

        <FormControl>
          <Input
            id="password"
            placeholder="PASSWORD"
            fullWidth
            type="password"
            value={password}
            onChange={(e): void => setPassword(e.target.value)}
            onKeyUp={validatePassword}
          />
        </FormControl>
        <FormControl>
          <div className={`must-container cfb ${password ? '' : 'd-none'}`}>
            {!userExist &&
              mustContainData.map(data => (
                <div className="MustContainItem" key={data.desc}>
                  <div className="must-item">
                    <li className={`must-text ${data.state ? 'text-success' : 'none'}`}>
                      {data.desc}
                    </li>
                  </div>
                </div>
              ))}
            {userExist && <li className="text-danger">{userExist}</li>}
          </div>
        </FormControl>
        <FormControl>
          <FormControlLabel
            style={{ padding: 0, margin: 0 }}
            control={
              <Checkbox
                checked={checkedTerms}
                onChange={onTermsChange}
                name="checkedA"
                color="primary"
                className="check-term"
              />
            }
            label={
              <>
                I agree to Maverick&apos;s
                <a
                  href="https://maverickapp.io/msa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="terms-link"
                >
                  Terms and conditions
                </a>
              </>
            }
          />
        </FormControl>
        <Grid container spacing={3}>
          <Grid item xs={6}>
            <Button
              disabled={!validateForm() || isLoading}
              variant="contained"
              color="primary"
              fullWidth
              size="large"
              onClick={handleSubmit}
            >
              {isLoading && <CircularProgress size="1rem" className={classes.progress} />}
              LET&apos;S GO, GOOSE
            </Button>
          </Grid>
          <Grid item xs={6}>
            <Button fullWidth size="large" variant="contained" color="primary">
              SIGN IN
            </Button>
          </Grid>
        </Grid>
      </div>
    </div>
  )
}
export default SignupForm
